<template>
    <div>
        <a-button class="top_btn" type="primary" @click="()=>{  visibleForm = true; titleForm='添加消息' }"  > 添加消息
        </a-button>
        <a-table :columns="columns" :data-source="data" :loading="loading" :pagination="pagination" rowKey="id">
          <span slot="status" slot-scope="text, record" >
<!--              <a-switch   @onChange="statusChange(record)" :checked="text==1?true:false"    /> -->
          <a-switch   @click="statusChange(record)" :checked="text==1?true:false"/></span>
          <span slot="action" slot-scope="text, record"  >

        <a @click="(record)=>{visibleForm = true; titleForm='修改消息'; editId=text.id ; }"  >编辑</a>
              <a-divider type="vertical"/>
          <a-popconfirm
                  title="此操作将永久删除, 是否继续?"
                  ok-text="确定"
                  cancel-text="取消"
                  @confirm="confirm(record)"
                  @cancel="()=>{}"
          >
            <a>删除</a>
        </a-popconfirm>
      </span>
        </a-table>
        <PromptForm :visible="visibleForm" :title="titleForm" :editId="editId" @changVisible=" () => { this.visibleForm = false;this.editId='';  this.getList()}  "/>
    </div>

</template>

<script>
    import API from "./api";
    import PromptForm from "./add"
    import {changStatus, removeById} from "../../../utils/utils"
    const columns = [
        {
            title: "消息标题",
            dataIndex: "title",
            ellipsis: true,
            key: "title"
        },
        {
            title: "添加时间",
            dataIndex: "create_time",
            ellipsis: true,
            key: "create_time"
        },
        {
            title: "状态",
            key: "status",
            dataIndex: "status",
            scopedSlots: {customRender: "status"}
        },
        {
            title: "操作",
            key: "action",
            scopedSlots: {customRender: "action"}
        }
    ];
    export default {
        name: 'index',
        data() {
            return {
                pagination: {
                    pageNo: 1,
                    pageSize: 20, // 默认每页显示数量
                    onShowSizeChange: (pageSize) => (this.pageSize = pageSize), // 改变每页数量时更新显示
                    onChange: this.getList.bind(this), //点击页码事件
                    total: 0, //总条数
                    current: 0,
                    size: "small",
                    showTotal: total => `共 ${total} 条`,
                    showQuickJumper: true
                },
                visibleForm: false,
                titleForm: "",
                loading: true,
                editId: null,
                jurisdictionId: null,
                visibleJurisdiction: false,
                data: [],
                columns,
            }
        },
        created() {
            this.$store.state.adminleftnavnum = "/MessageManagement/MessagePrompt"; //设置左侧导航2-2 active
        },
         components: {PromptForm},
        methods: {
            getList(page) {
                this.loading = true
                API.prompt.GET_LIST(page || 1).then(res => {
                    this.pagination.total = res.data.data.total
                    this.pagination.pageSize = res.data.data.per_page
                    this.pagination.current = res.data.data.current_page
                    this.data = res.data.data.data
                    this.loading = false
                })
            },
          statusChange(row) {
            //
            //      let Json = {id: row.id, status: row.status == 1 ? 2 : 1}
            // console.log("row",Json)
            //      changStatus(API.prompt.CHANG_STATUS, [Json]).then(res => {
            //          if (res == true) {
            //              this.getList()
            //          }
            //      })
            let Json = {id: row.id, status: row.status == 1 ? 2 : 1}
            API.prompt.CHANG_STATUS([Json]).then(res => {
              this.getList()
            })

             },
            confirm(row) {
                removeById( API.prompt.DELE, [row.id]).then(res => {
                    if (res == true) {
                        this.getList()
                    }
                })
            },
        },
        mounted() {
            this.getList()
        }

    }
</script>
